export default "__VITE_ASSET__hdztYFiI__"